import React                from 'react';
import PropTypes            from 'prop-types';
import { 
    Base, 
    Content, 
    Wrapper 
}                           from './components'; 

class Button extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    createComponentClasses() {
        let {
            size,
            className
        } = this.props;

        let classNames = ['marketkit-button primary'];

        if (size)           classNames.push(size);
        if (className)      Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    isInteractive() { return !this.props.isDisabled && !this.props.isLoading; }

    onClick(e) {
        let { onClick } = this.props;
        onClick();
    }
    
    render() {
        let {
            label,
            className,
            isCustomLabelType,
            isDisabled
        } = this.props;
        
        return (
            <Base
                className       = { this.createComponentClasses() }
                onClick         = { (e) => this.onClick(e) }
                isDisabled      = { isDisabled }
            >
                <Wrapper 
                    className       = { className } 
                >
                    <Content>
                        { !isCustomLabelType ? label.toLocaleUpperCase('en-US') : label }
                    </Content>
                </Wrapper>
            </Base>
        );
    }
}

Button.propTypes = {
    className           : PropTypes.string,
    label               : PropTypes.string,
    isCustomLabelType   : PropTypes.bool,
    size                : PropTypes.string,
    onClick             : PropTypes.func,
    isDisabled          : PropTypes.bool,
};

Button.defaultProps = {
    label               : '',
    size                : '',
    isCustomLabelType   : false, 
    isDisabled          : false,
    onClick             : () => {},
};

export default Button;